<template>
    <div class="content-component">
        <div v-html="component.html"></div>
    </div>
</template>

<script>
//import Profile from '../Profile.vue'

export default {
    name: 'Content',
    components: {
    },
    props: {
        component: Object,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {

    }
}

</script>

<style>

</style>

